import { render, staticRenderFns } from "./KTag.vue?vue&type=template&id=cf94e85a&scoped=true&lang=pug&"
import script from "./KTag.vue?vue&type=script&lang=ts&"
export * from "./KTag.vue?vue&type=script&lang=ts&"
import style0 from "./KTag.vue?vue&type=style&index=0&id=cf94e85a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf94e85a",
  null
  
)

/* custom blocks */
import block0 from "./KTag.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports